export default "__VITE_ASSET__DVJtcZiJ__"